var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2374 5105 c-541 -84 -955 -517 -1023 -1070 -6 -49 -11 -179 -11 -287 l0 -198 169 0 169 0 5 238 c4 195 9 252 26 320 66 263 238 471 483 587 125 59 214 78 368 78 107 0 151 -4 215 -22 318 -86 556 -326 636 -643 17 -68 22 -125 26 -320 l5 -238 169 0 169 0 0 190 c0 221 -12 345 -45 478 -28 107 -111 286 -176 379 -271 382 -730 579 -1185 508z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 1605 l0 -1605 1910 0 1910 0 0 1605 0 1605 -1910 0 -1910 0 0 -1605z m2085 890 c89 -24 173 -73 246 -146 217 -216 212 -558 -11 -773 -44 -43 -92 -77 -134 -97 l-66 -31 0 -391 c0 -243 -4 -406 -11 -430 -47 -172 -289 -166 -329 9 -5 21 -10 213 -10 426 l0 386 -64 30 c-88 41 -193 143 -240 231 -163 310 -4 687 329 782 76 22 213 24 290 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.6d5d924a0099eb6e3f73e06182ebc407.svg";
export { ForwardRef as ReactComponent };